import { UserManagement } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// UserManagementServices contains functions to interact with user management-related APIs.
// Each function corresponds to a specific API endpoint for tasks such as fetching users, updating user status, etc.
export const UserManagementServices = {
  /**
   * Function for fetching user data based on query parameters.
   * @param {Object} queryParams - Query parameters for fetching users.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get users API.
   */
  getUserService: async ({ queryParams }) => {
    try {
      const payload = {
        ...UserManagement.getUsers,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating the status of a user.
   * @param {string} id - ID of the user whose status needs to be updated.
   * @param {Object} bodyData - Updated user status information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update user status API.
   */
  UpdateUserStatusService: async (id, bodyData) => {
    try {
      const payload = {
        ...UserManagement.updateUserStatus(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for fetching data of a single user.
   * @param {string} id - ID of the user to be fetched.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get single user API.
   */
  getSingleUserService: async (id) => {
    try {
      const payload = {
        ...UserManagement.getSingleUser(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for fetching data of a single user transaction.
   * @param {string} id - ID of the user to be fetched.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get single user API.
   */
  getSingleUserTransactionService: async (queryParams) => {
    try {
      const payload = {
        ...UserManagement.getSingleUserTransaction,
        queryParams
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

   /**
   * Function for updating the data of a user.
   * @param {string} id - ID of the user whose data needs to be updated.
   * @param {Object} bodyData - Updated user data information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update user data API.
   */
   updateUserDataService: async (id, bodyData) => {
    try {
      const payload = {
        ...UserManagement.updateUserDetail(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
   /**
   * Function for delete a user.
   * @param {string} id - ID of the user whose data needs to be delete.
   * @returns {Promise<Object>} - A promise that resolves to the response from the delete user data API.
   */
   deleteUserById: async (id) => {
    try {
      const payload = {
        ...UserManagement.deleteUserById(id)
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

};
